import Preload from "./preload";
import PuttGameScene from "./PuttGameScene";
import Phaser from "phaser";
import End from "./End";

export default class PuttGame {
  scenes = [];
  config = {
    type: Phaser.AUTO,
    parent: "minigame_container",
    width: 1920,
    height: 1080,
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    physics: {
        default: 'arcade',
        arcade: {          
            gravity: { y: 0 },       
        }
    },
    dom: {
      createContainer: true,
    },
    scene: this.scenes,
  };

  constructor() {
    this.scenes.push(Preload);
    this.scenes.push(PuttGameScene);
    this.scenes.push(End);
    this.game = new Phaser.Game(this.config);
  }

  cleanup() {
    const preloadScene = this.game.scene.getScene('Preload')
    const gameScene = this.game.scene.getScene('PuttGameScene')
    preloadScene.cleanup()
    gameScene.cleanup()
  }

}
